import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { H4 } from 'components/Typography';

import { colorAccent, mediaQueryMobileLargeMin } from 'styles';

export const LinksList = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const LinkItem = styled(Link)`
  font-size: 14px;
  color: ${colorAccent};
  padding: 8px 0;
  flex-basis: 100%;

  @media all and ${mediaQueryMobileLargeMin} {
    flex-basis: 50%;

    &:nth-child(odd) {
      padding-right: 16px;
    }
  }
`;

export const Title = styled(H4)`
  margin-bottom: 16px;
`;
